import { render, staticRenderFns } from "./PrivateImage.vue?vue&type=template&id=737baf94&"
import script from "./PrivateImage.vue?vue&type=script&lang=ts&"
export * from "./PrivateImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports